module.exports = __webpack_public_path__ + "img/giph-thumb.dc553a02.jpg";